<!-- Loading Screen -->

@if (isReportSending) {
  <div class="wrapper center"
    >
    <div class="inner">
      <mat-spinner> </mat-spinner>
    </div>
  </div>
}

<!-- Cancel Fishing Report-->

@if (!isReportSending) {
  <div class="container report-container"
    >
    <div class="container"
      style="padding-top: 20px;">
      <div class="row"
        align="center">
        @if (currPage <= numPages) {
          <h6 i18n>
        <small class="text-muted">
          Page {{currPage}} of {{numPages}}
        </small>
      </h6>
        }
        @if (currPage > numPages) {
          <h6 i18n>
        <small class="text-muted">
          Cancel Fishing Report
        </small>
      </h6>
        }
      </div>
      <div class="row"
        align="center">
        <div class="col-5"></div>
        <div class="col-2">
          @if (currPage <= numPages) {
            <mat-spinner
              mode="determinate"
              [diameter]="50"
              [strokeWidth]="6"
            [value]="spinnerProgress"></mat-spinner>
          }
          @if (currPage > numPages) {
            <mat-icon
              class="top-icon">
              check_circle_outline
            </mat-icon>
          }
        </div>
        <div class="col-5"></div>
      </div>
    </div>
    <!-- Comments -->
    @if (currPage === 1) {
      <div>
        <form [formGroup]="cancelForm">
          <div class="row"
            align="center">
            <h5 i18n class="blue-heading-title">
          Would you like to add a comment?
        </h5>
          </div>
          <div class="row">
            <h6 i18n class="blue-label">
          Comments 
        </h6>
            <mat-form-field appearance="fill">
              <mat-label i18n>
            Comments...
          </mat-label>
              <textarea matInput
                maxlength="300"
                rows="9"
              formControlName="comments"></textarea>
            </mat-form-field>
          </div>
        </form>
      </div>
    }
    <!-- Summary Page -->
    @if (currPage > numPages) {
      <div
        class="container details">
        <div class="row"
          align="center">
          <h5 i18n class="blue-heading-title">
        Is all information complete and ready to be submitted to DFO?
      </h5>
        </div>
        <div class="row">
          <h6 i18n class="blue-label">
        <b>
          Comments:
        </b>
        {{ cancelForm.get('comments')?.value }}
      </h6>
        </div>
      </div>
    }
    <!-- Page Navigation Buttons -->
    <div class="row bottom-buttons">
      <div class="col-1"></div>
      <div class="col-4">
        <div class="row"
          style="margin-top: 20px;">
          <button mat-raised-button
            class="fishing-button-blue"
            type="button"
            (click)="toPreviousPage()">
            <span i18n>
            Back
          </span>
          </button>
        </div>
      </div>
      <div class="col-2"></div>
      <div class="col-4">
        <div class="row"
          style="margin-top: 20px;">
          <button mat-raised-button
            class="fishing-button-red"
            type="submit"
            (click)="toNextPage()">
            @if (currPage <= numPages) {
              <span i18n>
            Next
          </span>
            }
            @if (currPage > numPages) {
              <span i18n>
            Submit
          </span>
            }
          </button>
        </div>
      </div>
      <div class="col-1"></div>
    </div>
  </div>
}
